module.exports = __webpack_public_path__ + "static/media/grip-lines-vertical.86428561.svg";